export const PULL_MERCHANT_INFO = 'Pull Merchant Info';
export const PULL_MERCHANT_LOCATIONS_INFO = 'Pull Merchant Locations Info';

export const ACTIONS = [PULL_MERCHANT_INFO, PULL_MERCHANT_LOCATIONS_INFO];
